/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { forwardRef } from "react";
import sass from "./tables.module.sass";

interface IHelperText {
	toggle: boolean;
}

const HelperText = forwardRef<any, IHelperText>(({ toggle }, ref) => {
	return toggle ? (
		<p ref={ref} className={sass.help_text}>
			Воспользуйтесь{" "}
			<a href={"https://bdu.fstec.ru/threat-section/shaper-threats"} rel="noreferrer" target={"_blank"}>
				калькулятором угроз ФСТЭК
			</a>{" "}
			для формирования таблицы данных по актуальным угрозам. Загрузите сформированный файл таблицы для заполнения части
			данных модели угроз.
		</p>
	) : null;
});

export default HelperText;
